import ReactModal from 'react-modal';

import {
  DecisionModalIcon,
  DecisionModalIconType,
} from '../../../Signup/components/DecisionModal/DecisionModalIcon';

export const PostCheckoutDecisionModal = ({ isOpen }: { isOpen: boolean }) => {
  return (
    <ReactModal
      className="absolute left-1/2 top-1/2 flex min-h-[288px] w-full max-w-[301px] -translate-x-1/2 -translate-y-1/2 flex-col rounded-s border border-secondary-80 bg-white p-l shadow-black-m outline-none"
      overlayClassName="fixed z-[15] inset-0 bg-overlay-decision-modal"
      isOpen={isOpen}
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
    >
      <DecisionModalIcon type={DecisionModalIconType.LOADING} />
      <div className="flex grow items-center justify-center">
        <p className="mb-l text-center text-m font-reg text-structure-40">
          Please wait while we process your application
        </p>
      </div>
    </ReactModal>
  );
};
